import React, {useEffect, useState} from "react";
import {t} from "i18next";
import {useDispatch} from "react-redux";
import {columns} from "./Columns";
import {ConfigKeyword} from "./ConfigKeyword";
import {setHeader} from "../../../../redux/actions/layout/interaction/action";
import TimesheetFormula from "./add";
import TableTitle from "../../../../common/list/components/TableTitle";
import {useSearchParams} from "react-router-dom";
import CommonList from "../../../../common/list";
import FilterTimeSheet from "./FilterTimeSheet";
import {usedGraphqlLazyQuery} from "../../../../custom/graphql/graphql-client";
import {useLazyQuery} from "@apollo/client";
import {GET_FORMULA_BY_TYPES} from "../../../../api/setting/timekeeping/timekeeping-formula/apiGql";
import {TableConfigKeyword} from "./list/TableConfigKeyword";

const TimekeepingFormula = (props) => {

    const dispatch = useDispatch();
    const [SHIFT_KEYWORD, setSHIFT_KEYWORD] = useState([]);
    const [DATE_KEYWORD, setDATE_KEYWORD] = useState([]);
    const [OVERTIME_KEYWORD, setOVERTIME_KEYWORD] = useState([]);
    const [MISSION_KEYWORD, setMISSION_KEYWORD] = useState([]);
    const [HOURLY_LEAVE_KEYWORD, setHOURLY_LEAVE_KEYWORD] = useState([]);
    const [MONTHLY_APPLICATION_KEYWORD, setMONTHLY_APPLICATION_KEYWORD] = useState([]);
    const [CHECK_INOUT_KEYWORD, setCHECK_INOUT_KEYWORD] = useState([]);
    const [searchParams] = useSearchParams();
    const [dataConfig,setDataConfig] = useState([])

    const [getFormulaKeyword] = useLazyQuery(GET_FORMULA_BY_TYPES)

    function Data(data, key) {
        // let res = {}
        // data?.map(item => {
        //     if(item?.example && item.example !== ""){
        //         res[item.column + "_EXAMPLE"] = item.example
        //
        //     }
        //         if(item?.note && item.note !== ""){
        //             res[item.column + "_NOTE"] = item.note
        //
        //         }
        //         res[item.column ] = item.name
        //
        //     })
        // console.log(" key ", {key,res}  )


        let shiftKeyword = []
        data?.forEach((item) => {
            if (item.customFormula) {
                shiftKeyword.push(
                    {
                        column: <span style={{color: "red"}}>{item.column}</span>,
                        name: <span style={{color: "red"}}>{item.name}</span>,
                        defaultValue: <span style={{color: "red"}}>{item.defaultValue}</span>,
                        example: <span style={{color: "red"}}>{item.example}</span>,
                        note: <span style={{color: "red"}}>{item.note}</span>
                    }
                )
            } else {
                shiftKeyword.push(
                    {
                        column: <span>{item.column}</span>,
                        name: <span>{item.name}</span>,
                        defaultValue: <span>{item.defaultValue}</span>,
                        example: <span>{item.example}</span>,
                        note: <span>{item.note}</span>
                    }
                )
            }
        })
        switch (key) {
            case "SHIFT_KEYWORD":
                setSHIFT_KEYWORD(shiftKeyword);
                break
            case "OVERTIME_KEYWORD":
                setOVERTIME_KEYWORD(shiftKeyword);
                break
            case "MONTHLY_APPLICATION_KEYWORD":
                setMONTHLY_APPLICATION_KEYWORD(shiftKeyword);
                break
            case "DATE_KEYWORD":
                setDATE_KEYWORD(shiftKeyword);
                break
        }

    }

    useEffect( () => {
        dispatch(setHeader(t('formulaTitle.timekeepingFormula'), null))
        const fetchData = async () => {
            try {
                const dataSummary = [];

                const [
                    shiftRes,
                    dateRes,
                    overtimeRes,
                    missionRes,
                    hourlyLeaveRes,
                    monthlyApplicationRes,
                    checkInOutRes
                ] = await Promise.all([
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.SHIFT_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.DATE_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.OVERTIME_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.MISSION_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.HOURLY_LEAVE_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.MONTHLY_APPLICATION_KEYWORD}),
                    usedGraphqlLazyQuery(getFormulaKeyword, {type: ConfigKeyword.CHECK_INOUT_KEYWORD})
                ]);

                Data(shiftRes?.data?.formulaKeyword?.items, ConfigKeyword.SHIFT_KEYWORD);
                dataSummary.push(...(shiftRes?.data?.formulaKeyword?.items || []));

                Data(dateRes?.data?.formulaKeyword?.items, ConfigKeyword.DATE_KEYWORD);
                dataSummary.push(...(dateRes?.data?.formulaKeyword?.items || []));

                Data(overtimeRes?.data?.formulaKeyword?.items, ConfigKeyword.OVERTIME_KEYWORD);
                dataSummary.push(...(overtimeRes?.data?.formulaKeyword?.items || []));

                setMISSION_KEYWORD(missionRes?.data?.formulaKeyword?.items || []);

                setHOURLY_LEAVE_KEYWORD(hourlyLeaveRes?.data?.formulaKeyword?.items || []);

                Data(monthlyApplicationRes?.data?.formulaKeyword?.items, ConfigKeyword.MONTHLY_APPLICATION_KEYWORD);
                dataSummary.push(...(monthlyApplicationRes?.data?.formulaKeyword?.items || []));

                setCHECK_INOUT_KEYWORD(checkInOutRes?.data?.formulaKeyword?.items || []);

                setDataConfig(dataSummary);
            } catch (error) {
            }
        }
        fetchData().then(r => {})

    }, [])

    const getTableListByTabKey = () => {
        switch (searchParams.get("tabKey")) {
            case ConfigKeyword.SHIFT_KEYWORD:
            default :
                return <TimesheetFormula
                    dataConfig = {dataConfig}
                />

            case ConfigKeyword.KEYWORD:
                return <CommonList
                    hasIndex={true}
                    columns={columns}
                    dataSource={SHIFT_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 1500}}
                />

            case ConfigKeyword.DATE_KEYWORD:
                return <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={DATE_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
            case ConfigKeyword.OVERTIME_KEYWORD:
                return <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={OVERTIME_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
            case ConfigKeyword.MISSION_KEYWORD:
                return <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={MISSION_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
            case ConfigKeyword.HOURLY_LEAVE_KEYWORD:

                return <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={HOURLY_LEAVE_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
            case ConfigKeyword.MONTHLY_APPLICATION_KEYWORD:

                return <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={MONTHLY_APPLICATION_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
            case ConfigKeyword.CHECK_INOUT_KEYWORD:
                return CHECK_INOUT_KEYWORD && <TableConfigKeyword
                    hasIndex={true}
                    // columns={columns}
                    dataSource={CHECK_INOUT_KEYWORD}
                    totalCount={0}
                    pagination={false}
                    bordered
                    scroll={{x: 0}}
                />
        }
    }

    return (
        <div className={'h-full overflow-hidden'}>

            {(!!searchParams.get("tabKey") && searchParams.get("tabKey") !== ConfigKeyword.SHIFT_KEYWORD) && (
                <TableTitle
                    title={<FilterTimeSheet title={t("tnp.components.timekeeping.text55")}/>}
                />
            )}
            {
                getTableListByTabKey()
            }
        </div>
    )
}

export default TimekeepingFormula;